<template>
  <div id="unity3dBar" class="unityBar_Dark">
    <div class="unitybar_inner">
      <div
        class="titlemenu"
        v-show="!isNewEdition && !isShowType2D"
        :class="[showRoad ? 'titlemenu_active' : '']"
      >
        <span class="titlemenu-span" title="道路清洁" @click="roadClick">道路清洁</span>
      </div>
      <div
        class="titlemenu"
        :class="[showVehicles ? 'titlemenu_active' : '']"
        v-show="isNewEdition && !isShowType2D"
      >
        <span class="titlemenu-span" title="环保车辆" @click="vehiclebtn">环保车辆</span>
      </div>
      <div
        class="titlemenu"
        :class="[showVehicles_mathRoad ? 'titlemenu_active' : '']"
        v-show="false"
      >
        <!-- 新版的环保车辆 -->
        <span class="titlemenu-span" title="环保车辆" @click="vehiclebtn2">环保车辆</span>
      </div>

      <div
        class="titlemenu"
        v-show="isNewEdition && !isShowType2D"
        :class="[showMonitor ? 'titlemenu_active' : '']"
      >
        <span class="titlemenu-span" title="道路监控" @click="monitorClick"
          >道路监控</span
        >
      </div>
      <div
        class="titlemenu"
        v-show="isNewEdition && !isShowType2D"
        :class="[titlemenu.pm10 ? 'titlemenu_active' : '']"
      >
        <span class="titlemenu-span" title="PM10" @click="PM10Click">PM10</span>
        <div class="submenu" :class="[titlemenuBlock.pm10 ? 'displaynone' : '']">
          <div class="submenu-item">
            <input id="pm10poi" type="checkbox" v-model="showPM10POI" />
            <label for="pm10poi" :class="[showPM10POI ? 'color-6EECFF' : '']"
              >POI展示</label
            >
          </div>
          <div class="submenu-item" v-show="false">
            <input id="pm10zz" type="checkbox" v-model="showPM10Cylinder" />
            <label for="pm10zz" :class="[showPM10Cylinder ? 'color-6EECFF' : '']"
              >柱状展示</label
            >
          </div>
          <div class="submenu-item" v-show="false">
            <input id="pm10rlt" type="checkbox" v-model="showPM10HeatMap" />
            <label for="pm10rlt" :class="[showPM10HeatMap ? 'color-6EECFF' : '']"
              >热力图</label
            >
          </div>
        </div>
      </div>
      <div
        class="titlemenu"
        :class="[autoVision ? 'titlemenu_active' : '']"
        v-show="false"
      >
        <span class="titlemenu-span" title="自动巡查" @click="autoVisionClick"
          >自动巡查</span
        >
      </div>
      <div class="titlemenu" v-show="isNewEdition && !isShowType2D">
        <span
          class="titlemenu-span"
          :title="showBuilding ? '隐藏建筑' : '显示建筑'"
          @click="switchBuilding"
          >{{ showBuilding ? "隐藏建筑" : "显示建筑" }}</span
        >
      </div>
      <div class="titlemenu" v-show="isNewEdition && !isShowType2D">
        <span
          class="titlemenu-span"
          :title="show2dMap ? '2D地图' : '2D地图'"
          @click="switch2dMap"
          >{{ show2dMap ? "2D地图" : "2D地图" }}</span
        >
      </div>
      <div class="titlemenu" :class="[showVDM ? 'titlemenu_active' : '']" v-show="false">
        <span class="titlemenu-span" title="VDM" @click="VDMClick()">VDM</span>
      </div>
      <div
        class="titlemenu clearMod"
        :class="[!showClearMod ? 'titlemenu_active' : '']"
        v-show="!isNewEdition"
      >
        <span class="titlemenu-span" :title="'精简模式'" @click="switchClearMod">{{
          "精简模式"
        }}</span>
      </div>
      <!-- <div
        class="titlemenu"
        :class="[isShowType2D ? 'titlemenu_active' : '']"
        v-show="isNewEdition"
      >
        <span
          class="titlemenu-span"
          :title="isShowType2D ? '显示3D地图' : '显示2D地图'"
          @click="changeIsShowTypeStatus()"
          >{{ isShowType2D ? "显示3D地图" : "显示2D地图" }}</span
        >
      </div> -->
      <!--views class="titlemenu" v-if="bme3dManagerLoaded && false" /-->
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
//import player from "@/components/player";
//import loading from "@/components/loading";
import { roadDataList } from "@/views/ColorScreenMod/roadList.js";
import cameraList from "@/views/ColorScreenMod/cameraList.js";

import {
  LoadLabelFunc,
  DestroyLabelFunc,
  CleanCarStopFunc,
  RealTimeCleanCarStartFunc,
  IsShowBoidsFunc,
  IsShowTargetFunc,
  setDayFunc,
  IsShowBuildingsFunc,
  LoadPathFromJSFunc,
  StopPathFunc,
  OpenBGFunc,
  RoadHeatLineFunc,
  HideHeatLineFunc,
  ShowHeatLineFunc,
  LoadCruiseJsonFunc,
  LoadCruiseNetworkFunc,
  StartCruiseFunc,
  ShowOrHideTerrianMapFunc,
  RealTimeWebCCStartFunc,
  IsShowAllBuildingsFunc,
} from "@/assets/js/unity3D/index.js";

import { unref } from "vue";

export default {
  name: "indexUnity3DBar",
  //components: { player, loading, views },
  components: {},
  inject: ["updateComponentsClose", "getRoadStatus", "changeIsShowType2D"],
  data() {
    return {
      tableData: [],
      titlemenuShow_: {
        show: true,
        list: [],
      },
      customerId: this.$store.state.customerId,
      bme3dManagerLoaded: false,

      started: false,
      getDataTip: "获取数据完成",
      poi: true,
      heatmap: true,
      cylinder: false,
      databox: false,
      // show property
      showPM10HeatMap: false,
      showPM10POI: false,
      showPM10Cylinder: false,
      showVehicles: false,
      showVehicles_mathRoad: false,
      showMonitor: false,
      autoVision: false,
      showBuilding: true,
      show2dMap: true,
      showRoad: false,
      showVDM: false,
      isGettingHistoryData: false,
      getKrigingHistoryDataError: false,
      hasKrigingHistoryData: false,
      isGettingRealTimeData: false,
      isShowType2D: false,
      vdmTspShow: false,

      titlemenu: {
        showRoad: false,
        vehicles: false,
        showMonitor: false,
        autoVision: false,
        pm10: false,
        showVDM: false,
      },
      titlemenuBlock: {
        pm10: false,
      },
      curPois: "",
      isFlyAround: false,

      setDayTimer: null,
      showClearMod: true,
      isNewEdition: true, //bmeConfig.isNewMathRoad,
      rotationCarPopupTimer: null,
      currentCarArrIndex: 0,
      onceCarPopupNum: bmeConfig.newMathRoadConfig.onceCarPopupNum,
      rotationCarPopupInterval: bmeConfig.newMathRoadConfig.rotationCarPopupInterval,
    };
  },
  props: ["hideGas", "titlemenuShow", "showCarInfo", "closeVehicleTag"], //隐藏气体
  watch: {
    closeVehicleTag: {
      handler(val, oldVal) {
        if (val) {
          this.vehiclebtn();
        }
      },
      deep: true,
    },
    showPM10HeatMap: {
      handler(val, oldVal) {
        if (val) {
          var hitMapUrl =
            "http://47.105.46.104:10100/BMEWebService.asmx/GetKriging_Real?Custom_ID=42";
          OpenBGFunc(hitMapUrl);
        }
      },
      deep: true,
    },
    showVehicles: {
      handler(val, oldVal) {
        if (val) {
          let url =
            bmeConfig.baseUrl +
            "/" +
            CONFIG.requestName +
            "/realtime/cleaner?customerId=" +
            parseInt(bmeConfig.customerSign);
          RealTimeCleanCarStartFunc(url);
          this.dayNightSwitch();
          this.carPopupClose();
        } else {
          this.curPois = "";
          this.dayNightSwitch();
        }
      },
      deep: true,
    },
    showCarInfo: {
      handler(val, oldVal) {
        //this.showVehicles_mathRoad = val;
      },
      deep: true,
    },
    /*showVehicles_mathRoad: {
      handler(val, oldVal) {
        if (val) {
          this.vehiclebtn2_Func();
        } else {
          CleanCarStopFunc();
          if (this.rotationCarPopupTimer) {
            clearTimeout(this.rotationCarPopupTimer);
          }
        }
      },
      deep: true,
    },*/
    titlemenuShow: {
      handler(val, oldVal) {
        this.hideAllData();
        this.titlemenuShow_ = val;
      },
      deep: true,
    },
    showVDM: {
      async handler(newVal, oldVal) {
        if (newVal) {
          //this.$popupInfo.key = "VMD";
          this.dayNightSwitch();
          DestroyLabelFunc();

          window.bubbleJson = "";
          var tmpList = await this.getVdmRoadData();
          var vdmObj = {
            dataList: [],
            seriseId: "2",
            poisType: "VDMRoad",
            callBackFunc: "poisClick",
            aggregated: "false",
          };
          tmpList.forEach((item) => {
            if (item.latitude && item.longitude) {
              let tmpColor = 0;
              if (item.value < 10) {
                tmpColor = 30;
              } else if (item.value < 100) {
                tmpColor = 60;
              } else {
                tmpColor = 100;
              }
              vdmObj.dataList.push({
                lat: item.latitude,
                lng: item.longitude,
                id: item.SN,
                value: item.value,
                color: tmpColor,
              });
            }
          });
          window.bubbleJson = JSON.stringify(vdmObj);
          LoadLabelFunc(window.bubbleJson);
        } else {
          this.dayNightSwitch();
          DestroyLabelFunc();
          this.curPois = "";
        }
      },
      deep: true,
    },
    showRoad: {
      async handler(newVal, oldVal) {
        /*if (newVal) {
          await this.getListData();
          let AllJson = new Array(65);
          for (let i = 0; i < AllJson.length; i++) {
            AllJson[i] = { roadID: "42_" + (i + 1), value: 30 };
          }
          let HLJson = [];
          this.tableData.forEach((item) => {
            let json = {
              roadID: item.modelId,
              value: this.getRoadValue(item.dryWetStatus),
            };
            HLJson.push(json);
          });
          AllJson.forEach((item, i) => {
            HLJson.forEach((item_, i_) => {
              if (item.roadID == item_.roadID) {
                item.value = item_.value;
              }
            });
          });
          RoadHeatLineFunc(JSON.stringify(AllJson));
          ShowHeatLineFunc();
        } else {
          HideHeatLineFunc();
        }*/
      },
      deep: true,
    },
    showPM10POI: {
      handler(newVal, oldVal) {
        this.getMonitorAndPM10();
      },
      deep: true,
    },
    showBuilding: {
      handler(newVal, oldVal) {
        if (newVal) {
          IsShowBuildingsFunc("true");
        } else {
          IsShowBuildingsFunc("false");
        }
      },
      deep: true,
    },
    autoVision: {
      handler(newVal, oldVal) {
        if (newVal) {
          if (!this.showBuilding) {
            this.showBuilding = true;
          }
          if (this.showRoad) {
            this.showRoad = false;
          }
          this.$forceUpdate();

          this.$nextTick(() => {
            this.$router.push({
              path: `/AutoVision`,
              hash: "",
            });
            setTimeout(() => {
              LoadCruiseJsonFunc();
            }, 100);
            setTimeout(() => {
              LoadCruiseNetworkFunc();
            }, 100);
            setTimeout(() => {
              StartCruiseFunc();
            }, 500);
          });
        }
      },
      deep: true,
    },
    showMonitor: {
      handler(newVal, oldVal) {
        this.getMonitorAndPM10();
      },
      deep: true,
    },
    getRoadStatus: {
      async handler(newVal, oldVal) {
        /*if (newVal) {
          let ts = unref(newVal);
          if (this.showRoad) {
            await this.getListData();
            let AllJson = new Array(65);
            for (let i = 0; i < AllJson.length; i++) {
              AllJson[i] = { roadID: "42_" + (i + 1), value: 30 };
            }
            let HLJson = [];
            this.tableData.forEach((item) => {
              let json = {
                roadID: item.modelId,
                value: this.getRoadValue(item.dryWetStatus),
              };
              HLJson.push(json);
            });
            AllJson.forEach((item, i) => {
              HLJson.forEach((item_, i_) => {
                if (item.roadID == item_.roadID) {
                  item.value = item_.value;
                }
              });
            });
            RoadHeatLineFunc(JSON.stringify(AllJson));
            ShowHeatLineFunc();
          }
        }*/
      },
      deep: true,
    },
    showClearMod: {
      handler(newVal, oldVal) {
        ShowOrHideTerrianMapFunc(!newVal);
        IsShowAllBuildingsFunc(newVal);
      },
      deep: true,
    },
  },
  computed: {
    getRoadValue() {
      return (value) => {
        let roadStatus = [
          {
            status: "干燥",
            value: 100,
          },
          {
            status: "中等",
            value: 51,
          },
          {
            status: "湿润",
            value: 1,
          },
        ];
        let arr = roadStatus.filter((i) => i.status == value);
        if (arr[0]) {
          return arr[0].value;
        } else {
          return "100";
        }
      };
    },
  },
  created() {},
  mounted() {
    this.titlemenuShow_ = this.titlemenuShow;

    this.$carPopupClickFunc.cb = this.carPopupClickFunc;

    this.$roadVideoFunc.cb = this.roadVideoFunc_;

    //IsShowBoidsFunc();
    setTimeout(() => {
      IsShowBoidsFunc("true");
    }, 500);

    setTimeout(() => {
      IsShowTargetFunc("false");
      //IsShowBuildingsFunc("false");
    }, 500);

    let that = this;
    this.$closeCar.cb = function () {
      //that.dayNightSwitch();
      that.showVehicles = false;
    };

    // this.roadClick();
    if (this.isNewEdition) {
      this.vehiclebtn();
      // this.switchClearMod();//进来直接精简模式
    } else {
      this.vehiclebtn();
    }

    this.monitorClick();

    //this.changeIsShowType2D(true);
  },
  //mounted
  beforeUnmount() {
    if (HideHeatLineFunc) {
      HideHeatLineFunc();
    }
    if (DestroyLabelFunc) {
      DestroyLabelFunc();
    }
    if (CleanCarStopFunc) {
      CleanCarStopFunc();
    }
    if (IsShowBuildingsFunc) {
      IsShowBuildingsFunc("true");
    }
    if (this.setDayTimer) {
      clearInterval(this.setDayTimer);
    }
    if (ShowOrHideTerrianMapFunc && IsShowAllBuildingsFunc) {
      ShowOrHideTerrianMapFunc(false);
      IsShowAllBuildingsFunc(true);
    }
    if (this.rotationCarPopupTimer) {
      clearTimeout(this.rotationCarPopupTimer);
    }
  },
  unmounted() {},
  methods: {
    roadVideoFunc_(xbsjGuid) {
      let curItem = "";
      try {
        cameraList.forEach((item) => {
          if (item.id == xbsjGuid) {
            curItem = $.extend(true, {}, item);
            throw Error("当前播放视频");
          }
        });
      } catch (err) {
        console.log(err);
      }
      curItem.curT = new Date().getTime();
      this.$emit("openCamera", curItem);
    },
    carPopupClickFunc(carNum) {
      this.$emit("clickCarNum", carNum);
    },
    carPopupClose() {
      this.$emit("closeCarNum");
    },
    changeIsShowTypeStatus() {
      this.isShowType2D = !this.isShowType2D;
      this.changeIsShowType2D(this.isShowType2D);
    },
    switchClearMod() {
      // this.showBuilding = !this.showBuilding;
      this.showClearMod = !this.showClearMod;
    },
    async getMonitorAndPM10() {
      DestroyLabelFunc();
      setTimeout(() => {
        if (this.showMonitor) {
          window.bubbleJson = "";
          //var tmpList = await this.getVideoData();
          var roadObj = {
            dataList: [],
            seriseId: "4",
            poisType: "roadVideo",
            callBackFunc: "poisClick",
            aggregated: "false",
          };
          cameraList.forEach((item) => {
            if (item.latitude && item.longitude) {
              roadObj.dataList.push({
                lat: item.latitude,
                lng: item.longitude,
                id: item.id,
                value: 0,
                color: 30,
              });
            }
          });
          console.log(JSON.stringify(roadObj))
          window.bubbleJson = JSON.stringify(roadObj);
          LoadLabelFunc(window.bubbleJson);
        }

      }, 500);
      if (this.showPM10POI) {
        window.bubbleJson = "";
        var tmpList = await this.getPM10Data();
        var pm10Obj = {
          dataList: [],
          seriseId: "1",
          poisType: "PM10",
          callBackFunc: "poisClick",
          aggregated: "false",
        };
        tmpList.forEach((item) => {
          if (item.latitude && item.longitude) {
            let tmpColor = 0;
            if (item.value < 100) {
              tmpColor = 30;
            } else if (item.value < 200) {
              tmpColor = 60;
            } else {
              tmpColor = 100;
            }
            pm10Obj.dataList.push({
              lat: item.latitude,
              lng: item.longitude,
              id: item.SN,
              value: item.value,
              color: tmpColor,
            });
          }
        });
        window.bubbleJson = JSON.stringify(pm10Obj);
        LoadLabelFunc(window.bubbleJson);

        window.bubbleJson = "";
        var tmpList = await this.getPM10VdmData();
        var pm10Obj = {
          dataList: [],
          seriseId: "2",
          poisType: "PM10Vdm",
          callBackFunc: "poisClick",
          aggregated: "false",
        };
        tmpList.forEach((item) => {
          if (item.latitude && item.longitude) {
            let tmpColor = 0;
            if (item.value < 100) {
              tmpColor = 30;
            } else if (item.value < 200) {
              tmpColor = 60;
            } else {
              tmpColor = 100;
            }
            pm10Obj.dataList.push({
              lat: item.latitude,
              lng: item.longitude,
              id: item.SN,
              value: item.value,
              color: tmpColor,
            });
          }
        });
        window.bubbleJson = JSON.stringify(pm10Obj);
        LoadLabelFunc(window.bubbleJson);
      }
    },
    async vehiclebtn2_Func() {
      console.log("indexDarkUnityRoad - carDetail");
      return;
      let that = this;
      let url = `${bmeConfig.baseUrl}/${
        CONFIG.requestName
      }/realtime/cleaner?customerId=${parseInt(bmeConfig.customerSign)}`;
      let result = await that.$apiUtils.get(url);
      // console.log("result", result);
      // console.log("jsonCCStr", jsonCCStr);
      let carArr = [];
      result &&
        result.forEach((item, i) => {
          let roadName =
            roadDataList.find((item_) => item_.model_id == item.roadModelId)?.road_name ??
            "未知道路";
          let webUrl = encodeURI(
            // `http://127.0.0.1:5502/standard/page/shedDialogRF/mathRoad/carDetail.html?deviceName=${item.deviceName}&cleaningRoad=${roadName}&cleanDistance=${item.todayDistance}`
            `https://vis.bmetech.com/standard/vis/page/shedDialogRF/mathRoad/carDetail.html?dtuNum=${item.dtuNum}&deviceName=${item.deviceName}&cleaningRoad=${roadName}&cleanDistance=${item.todayDistance}`
          );
          let obj = { dtuNum: item.dtuNum, url: webUrl };
          carArr.push(obj);
        });
      // console.log("carArr", carArr);
      this.rotationCarPopup(carArr, url);
      // if (jsonCCStr) jsonCCStr["CCUrl"] = carArr;
      // RealTimeWebCCStartFunc(url);
    },
    rotationCarPopup(carArr, url) {
      if (this.rotationCarPopupTimer) {
        clearTimeout(this.rotationCarPopupTimer);
      }
      let currentCarArr = [];
      for (let i = 0; i < this.onceCarPopupNum; i++) {
        if (carArr[this.currentCarArrIndex + i]) {
          currentCarArr.push(carArr[this.currentCarArrIndex + i]);
          // console.log(this.currentCarArrIndex + i);
        } else {
          this.currentCarArrIndex = -this.onceCarPopupNum;
          break;
        }
      }
      this.currentCarArrIndex += this.onceCarPopupNum;
      if (jsonCCStr) jsonCCStr["CCUrl"] = currentCarArr;
      RealTimeWebCCStartFunc(url);
      this.rotationCarPopupTimer = setTimeout(() => {
        this.rotationCarPopup(carArr, url);
      }, this.rotationCarPopupInterval);
    },
    async getListData() {
      try {
        const getRoadInfoList = CONFIG.requestName + this.$apiOpt.getRoadInfoList;
        let res = await this.$apiUtils.get(getRoadInfoList, {
          customerId: this.customerId,
        });
        if (res) {
          this.tableData = res;
        }
      } catch (err) {
        console.log(err);
      }
    },
    dayNightSwitch() {
      if (this.showPM10POI || this.showRoad || this.showVDM || this.showVehicles) {
        //setDayFunc("6.8");
      } else {
        //setDayFunc("10");
      }
    },
    async getVideoData() {
      let that = this;
      let getRoadCameraList = CONFIG.requestName + this.$apiOpt.roadCameraList;
      let result = await that.$apiUtils.get(getRoadCameraList, {
        customerId: that.$store.state.customerId,
        isMore: true,
      });
      let videoList = [];
      window.overalVideoData = new Object();
      result.forEach((element) => {
        let list = element.list;
        list.forEach((item) => {
          window.overalVideoData[item.ipAddress] = item;
          videoList.push({
            latitude: item.latitude,
            longitude: item.longitude,
            SN: item.ipAddress,
            value: 30,
          });
        });
      });
      return videoList;
    },
    async getPM10Data() {
      let that = this;
      let getMonitorUrl = CONFIG.requestName + that.$apiOpt.monitor;
      let result = await that.$apiUtils.get(getMonitorUrl, {
        customerId: that.$store.state.customerId,
        gas: "PM10",
      });
      window.overalPM10Data = new Object();
      result.forEach((item) => {
        window.overalPM10Data[item.SN] = item;
      });
      return result;
    },
    async getPM10VdmData() {
      let that = this;
      let getMonitorUrl = CONFIG.requestName + that.$apiOpt.vdmMonitor;
      let result = await that.$apiUtils.get(getMonitorUrl, {
        customerId: that.$store.state.customerId,
        gas: "PM10",
      });
      window.overalPM10VdmData = new Object();
      result &&
        result.forEach((item) => {
          window.overalPM10VdmData[item.SN] = item;
        });
      return result;
    },

    async getVdmRoadData() {
      let that = this;
      let getMonitorUrl = CONFIG.requestName + that.$apiOpt.vdmMonitor;
      let result = await that.$apiUtils.get(getMonitorUrl, {
        customerId: that.$store.state.customerId,
        gas: "roadVDM",
      });
      window.overalRoadVdmData = new Object();
      result.forEach((item) => {
        window.overalRoadVdmData[item.SN] = item;
      });
      return result;
    },
    reset() {
      this.start = this.stop = "";
    },
    flyAround() {
      /*this.isFlyAround = !this.isFlyAround;
      if (this.isFlyAround) {
        LoadPathFromJS();
      } else {
        StopPath();
      }*/
      //GetScreenPosFunc();
      var camRoamJson =
        '{"callBackFunc":"CamRoamStr","RoamPathID":"123","RoamTotalTime":300.0,"Positions":[{"x":1790.7125244140625,"y":149.13946533203126,"z":91.8331527709961},{"x":1782.879638671875,"y":129.75875854492188,"z":924.6639404296875},{"x":1745.8724365234375,"y":129.75875854492188,"z":1936.365478515625},{"x":1604.0572509765625,"y":139.75198364257813,"z":2377.62890625},{"x":943.46240234375,"y":152.21437072753907,"z":2379.48291015625},{"x":268.5043640136719,"y":152.21437072753907,"z":2319.746337890625},{"x":-22.660890579223634,"y":165.20681762695313,"z":2200.494384765625},{"x":-55.90118408203125,"y":172.3368682861328,"z":1348.2291259765625},{"x":25.064029693603517,"y":172.3811492919922,"z":371.98101806640627},{"x":90.61839294433594,"y":168.35748291015626,"z":-31.117164611816408},{"x":839.3344116210938,"y":115.92007446289063,"z":-20.080217361450197}],"Rotations":[{"x":0.18166275322437287,"y":-0.3975500762462616,"z":0.08062095195055008,"w":0.8957973122596741},{"x":0.11617366969585419,"y":-0.7097582817077637,"z":0.12050123512744904,"w":0.6842707395553589},{"x":0.11617366969585419,"y":-0.7097582817077637,"z":0.12050123512744904,"w":0.6842707395553589},{"x":0.07573027163743973,"y":-0.9224834442138672,"z":0.23612047731876374,"w":0.29586556553840639},{"x":-0.012008042074739933,"y":-0.9613168835639954,"z":0.27188798785209658,"w":-0.04245694726705551},{"x":-0.012008042074739933,"y":-0.9613168835639954,"z":0.27188798785209658,"w":-0.04245694726705551},{"x":-0.09795140475034714,"y":-0.8963342308998108,"z":0.24769900739192964,"w":-0.35445117950439455},{"x":0.20071765780448914,"y":0.6515741944313049,"z":-0.184730663895607,"w":0.7078404426574707},{"x":0.20071765780448914,"y":0.6515741944313049,"z":-0.184730663895607,"w":0.7078404426574707},{"x":0.25532686710357668,"y":0.3021143078804016,"z":-0.08437000215053559,"w":0.9145582914352417},{"x":0.23227916657924653,"y":-0.02884404920041561,"z":0.006891475524753332,"w":0.9721969962120056}],"isLoop":true,"isCurve":true}';
      if (!this.isFlyAround) {
        this.isFlyAround = true;
        LoadPathFromJSFunc(camRoamJson);
      } else {
        this.isFlyAround = false;
        StopPathFunc();
      }
    },
    hideAllData() {
      this.showPM10HeatMap = false;
      this.showPM25HeatMap = false;
      this.showPM10POI = false;
      this.showPM25POI = false;
      this.showPM10Cylinder = false;
      this.showPM25Cylinder = false;
      this.showDustPOI = false;
      this.showVehicles = false;
      this.showVocs = false;
      this.showRoad = false;
      this.isGettingHistoryData = false;
      this.getKrigingHistoryDataError = false;
      this.hasKrigingHistoryData = false;
      this.isGettingRealTimeData = false;
      this.showCOHeatMap = false;
      this.showCOPOI = false;
      this.showCOCylinder = false;
      this.showNO2HeatMap = false;
      this.showNO2POI = false;
      this.showNO2Cylinder = false;
      this.showSO2HeatMap = false;
      this.showSO2POI = false;
      this.showSO2Cylinder = false;
      this.showO3HeatMap = false;
      this.showO3POI = false;
      this.showO3Cylinder = false;
      this.titlemenu = {
        showRoad: false,
        vehicles: false,
        showMonitor: false,
        autoVision: false,
        pm10: false,
        showVDM: false,
      };
    },
    getUpdateStatus() {
      let result = false;
      if (this.titlemenu.showMonitor) {
        result = true;
      }
      if (this.titlemenu.pm10) {
        result = true;
      }
      if (this.titlemenu.potency) {
        result = true;
      }
      if (this.showVehicles) {
        result = true;
      }
      if (this.showVocs) {
        result = true;
      }
      /*if (this.showRoad) {
        result = true;
      }*/
      if (this.showVDM) {
        result = true;
      }
      return result;
    },
    vehiclebtn() {
      this.showVehicles = !this.showVehicles;
      if (!this.showVehicles) {
        CleanCarStopFunc();
      }
      if (this.getUpdateStatus()) {
        this.updateComponentsClose(true);
      } else {
        this.updateComponentsClose(false);
      }
    },
    vehiclebtn2() {
      this.showVehicles_mathRoad = !this.showVehicles_mathRoad;
    },
    roadClick() {
      this.showRoad = !this.showRoad;
      if (this.showRoad) {
        this.showRoad = true;
        /*this.titlemenu.pm10 = false;
        this.showPM10POI = false;
        this.showPM10HeatMap = false;
        this.showPM10Cylinder = false;
        this.showVDM = false;
        this.showMonitor = false;*/
        //this.showVehicles = false;
      }
    },
    VDMClick() {
      this.showVDM = !this.showVDM;
      if (this.showVDM) {
        this.showVDM = true;
        /*this.showRoad = false;
        this.titlemenu.pm10 = false;
        this.showPM10POI = false;
        this.showPM10HeatMap = false;
        this.showPM10Cylinder = false;
        //this.showVehicles = false;
        this.showMonitor = false;*/
      }
    },
    PM10Click() {
      this.titlemenu.pm10 = !this.titlemenu.pm10;
      if (this.titlemenu.pm10) {
        this.showPM10POI = true;
        this.titlemenu.pm10 = true;
        /*this.showRoad = false;
        this.showVDM = false;
        this.showPM10HeatMap = false;
        this.showPM10Cylinder = false;
        //this.showVehicles = false;
        this.showMonitor = false;*/
      } else {
        this.showPM10POI = false;
        this.titlemenu.pm10 = false;
        /*this.showRoad = false;
        this.showVDM = false;
        this.showPM10HeatMap = false;
        this.showPM10Cylinder = false;
        //this.showVehicles = false;
        this.showMonitor = false;*/
      }
    },
    monitorClick() {
      this.showMonitor = !this.showMonitor;
      /*if (this.showMonitor) {
        this.showMonitor = true;
        this.showRoad = false;
        this.titlemenu.pm10 = false;
        this.showPM10POI = false;
        this.showPM10HeatMap = false;
        this.showPM10Cylinder = false;
        this.showVDM = false;
        //this.showVehicles = false;
      }*/
    },
    autoVisionClick() {
      this.autoVision = !this.autoVision;
      /*if (this.autoVision) {
        this.autoVision = true;
        this.showRoad = false;
        this.titlemenu.pm10 = false;
        this.showPM10POI = false;
        this.showPM10HeatMap = false;
        this.showPM10Cylinder = false;
        this.showVDM = false;
        //this.showVehicles = false;
      }*/
    },
    switchBuilding() {
      this.showBuilding = !this.showBuilding;
    },
    switch2dMap() {
      this.$emit("switch2dMap", true);
    },
  },
};
</script>

<style scope lang="scss">
/* 数据回放 -- start */

.unityBar_Dark {
  pointer-events: auto;
  z-index: 997;
  height: 90px;
  line-height: 90px;
  display: flex;
  .unitybar_inner {
    display: flex;
    .titlemenu {
      width: 160px;
      padding: 8px 11px;
      margin-right: 32px;
      background: url("./img/road_bg.png");
      background-size: 100% 100%;
      .titlemenu-span {
        width: 140px;
        height: 66px;
        line-height: 54px;
        text-align: center;
        font-size: 24px;
      }
    }
    .titlemenu_active {
      background: url("./img/road_active_bg.png");
      background-size: 100% 100%;
    }
  }
}
.unitybar_inner {
  padding: 10px 50px;
}

.titlemenu-span {
  width: 100%;
  position: absolute;
  cursor: pointer;
}

.datebox {
  position: absolute;
  left: -215px;
  top: 100px;
  width: 500px;
  padding: 20px;
  overflow: hidden;
  background-image: url("/static/images/qiangang/dateboxbg.png");
  background-repeat: no-repeat;
  background-origin: border-box;
  background-size: 100% 100%;
}
.datebox .selectbox,
.datebox .timebox,
.datebox .typebox {
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;
}
.datebox .timebox {
  margin: 10px auto;
  justify-content: space-between;
}
.datebox .typebox input {
  margin: 0 10px;
}
/* 数据回放 -- end */

.player {
  position: fixed !important;
  left: 50%;
  bottom: 8vh;
  transform: translateX(-50%);
}
.unityBar_Dark .submenu {
  pointer-events: auto !important;
  margin-top: 75px !important;
}
.datebox .submenu-item {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
}
.datebox .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #fff;
}
.datebox .el-checkbox__label {
  display: inline-block;
  padding-left: 10px;
  line-height: 19px;
  font-size: 0.7vw;
  color: #fff;
}
.datebox .el-range-editor .el-range-input {
  line-height: 1;
  background-color: rgb(37, 76, 82);
  color: #fff;
}
.datebox .el-time-range-picker {
  width: 354px;
  overflow: visible;
  background-color: rgb(37, 76, 82);
  color: #fff;
}
.datebox .el-time-spinner__item.active:not(.disabled) {
  color: #fff;
  font-weight: 700;
  background-color: rgb(37, 76, 82);
}
.datebox .el-time-spinner__item {
  height: 32px;
  line-height: 32px;
  font-size: 0.7vw;
  color: #fff;
}
.datebox .el-time-spinner__item:hover:not(.disabled):not(.active) {
  background: rgb(55, 112, 121);
  cursor: pointer;
}
.datebox .el-time-panel__btn {
  border: none;
  line-height: 28px;
  padding: 0 5px;
  margin: 0 5px;
  cursor: pointer;
  background-color: transparent;
  outline: 0;
  font-size: 0.7vw;
  color: #fff;
}
.datebox .el-input--prefix .el-input__inner {
  color: #fff;
  /* width: 140px; */
  height: 34px;
  background-color: rgb(37, 76, 82);
}
.datebox .el-input__inner .el-date-editor.el-input,
.datebox .el-date-editor.el-input__inner {
  height: 32px;
  background-color: rgb(37, 76, 82);
  /* width: 220px; */
}
.datebox .el-input--prefix .el-input__inner {
  padding-left: 15px;
}
.datebox .el-select-dropdown,
.datebox .el-popper {
  border: 0;
}
.datebox .el-scrollbar__wrap,
.datebox .el-select-dropdown__item {
  background: rgba(16, 50, 72, 0.97);
}
.datebox .el-select-dropdown__item.hover,
.datebox .el-select-dropdown__item:hover {
  background: rgba(45, 86, 128, 1) !important;
}
.datebox .el-icon-arrow-up:before,
.datebox .el-icon-arrow-up:after {
  display: none;
}
.datebox .el-select .el-input .el-input__inner {
  font-size: 16px;
  color: #00adff !important;
  background-color: rgb(37, 76, 82);
  height: 34px;
  background-image: url("/static/images/qiangang/inputbg.png");
  background-size: 100% 100%;
}
.datebox .submenu-item label {
  font-size: 18px;
}
.datebox .el-date-editor .el-input__inner {
  font-size: 16px;
  color: #00adff !important;
  background-color: rgb(37, 76, 82);
  height: 34px;
  background-image: url("/static/images/qiangang/datepickerbg.png");
  background-size: 100% 100%;
}
.datebox .el-date-editor .el-input__prefix {
  display: none;
}
.datebox .el-select-dropdown__item {
  font-size: 1vw !important;
  color: #fff;
}
.datebox .comfirm-button {
  width: 80px;
  font-size: 18px;
  height: 38px;
  color: #fff;
  border: none;
  border-radius: 4px;
  background: linear-gradient(
    90deg,
    rgba(0, 138, 255, 0.8) 0%,
    rgba(0, 138, 255, 0.44) 73%,
    rgba(0, 138, 255, 0.3) 100%
  );
}
.datebox .reset-button {
  width: 80px;
  font-size: 18px;
  height: 38px;
  color: #fff;
  border: none;
  border-radius: 4px;
  background: transparent;
}
.datebox .el-select-dropdown__item.selected {
  color: #fff;
  font-weight: 700;
}
.datebox .el-select-dropdown__item.hover,
.datebox .el-select-dropdown__item:hover {
  background-color: rgba(45, 86, 128, 1) !important;
}
.datebox .el-input__icon,
.datebox .el-input__prefix {
  height: 100%;
  text-align: center;
  transition: all 0.3s;
}
.datebox .el-date-table {
  font-size: 0.8vw;
}
/*.el-date-picker__editor-wrap .el-input--small input {
  background-color: transparent;
  font-size: 0.8vw;
  color: white;
  border: none;
}
.el-date-picker {
  width: 470px;
  background: #0f1f27;
}*/
.datebox .el-date-picker .el-picker-panel__content {
  width: 450px;
}
.datebox .el-date-picker__header-label,
.datebox .el-picker-panel__icon-btn {
  font-size: 0.8vw;
  line-height: 30px;
  color: #ffffff;
}
.datebox .el-picker-panel__footer {
  background-color: rgba(16, 50, 72, 0.97);
}
.datebox .el-time-panel__footer {
  display: none;
  background-color: rgba(16, 50, 72, 0.97);
}
.datebox .el-input--small {
  background-color: transparent;
  background-image: url("/static/images/qiangang/inputbg.png");
  background-size: 100% 100%;
}
.datebox .available,
.datebox .el-date-table th {
  color: #ffffff;
}
.datebox .el-date-table td span {
  width: 1.5vw;
  height: 1.5vw;
  line-height: 1.5vw;
}
.datebox .el-time-range-picker__header {
  margin-bottom: 5px;
  text-align: center;
  font-size: 0.7vw;
}
.datebox .el-input__inner .el-date-editor.el-input,
.datebox .el-date-editor.el-input__inner {
  height: 32px;
  background-color: rgb(37, 76, 82);
  width: 220px;
  margin: 0.2vw 0 0.2vw 0;
}
.datebox .el-select {
  display: inline-block;
  position: relative;
  margin: 0.2vw 0 0.2vw 0;
  width: 48%;
}
.datebox .el-date-editor.el-input,
.datebox .el-date-editor.el-input__inner {
  margin: 0.2vw 0 0.2vw 0;
}
.datebox .el-date-editor.el-input,
.datebox .el-date-editor.el-input__inner {
  width: 50%;
}

.el-picker-panel__footer .el-button {
  /*height: 50px;
  line-height: 50px;*/
  font-size: 20px;
}
/* 去除此刻按钮 */
.el-picker-panel__footer .el-button:not(.is-plain) {
  display: none;
}
</style>
